<div
  #dropdownWrapper
  class="dropdown-wrapper"
  [class.dropdown-wrapper--disabled]="disabled"
  [class.dropdown-wrapper--without-hover]="withoutHover"
  [ngClass]="{error:isAutocomplete && error}"
>

  <div
    class="dropdown-select"
    (click)="openDropdown();openAutocomplete()"
    statistic
    statisticElementName="Open any dropdown"
  >

    <span class="dropdown-select__placeholder" *ngIf="placeholder && !label">{{placeholder}}</span>
    <span
      [class.dropdown-select__label--without-divider]="withoutDivider"
      class="dropdown-select__label"
      *ngIf="label"
    >
      {{label}}
    </span>
    <input
      #inputField
      class="dropdown-select__input"
      [style.width]="rubberInput ? viewValue?.toString().length * 8 + 'px' : '100%'"
      [readonly]="!isAutocomplete"
      [disabled]="disabled"
      [(ngModel)]="viewValue"
      (ngModelChange)="setAutocompleteList($event)"
      (keyup.enter)="onInputEnter()"
    />
  </div>

  <ng-container *ngIf="isDropdownOpened && !isAutocomplete">
    <ng-container *ngTemplateOutlet="dropdownList"></ng-container>
  </ng-container>

  <ng-container *ngIf="isDropdownOpened && isAutocomplete">
    <ng-container *ngTemplateOutlet="dropdownListAutocomplete"></ng-container>
  </ng-container>

</div>

<ng-template #dropdownList>
  <dx-scroll-view
    class="dropdown-items-wrapper"
    [class.mac]="isMac"
    [height]="height"
    [width]="contentWidth ? dropdownWrapper.clientWidth : ''"
    direction="Both"
  >
    <div
      class="dropdown-item"
      *ngFor="let item of listValues"
      (click)="selectItem(item)"
      statistic
      statisticElementName="Select item in any dropdowns"
    >
      <span class="dropdown-item__text">{{templateField ? item[templateField.list] : item}}</span>
      <div class="dropdown-item__divider"></div>
    </div>
  </dx-scroll-view>
</ng-template>

<ng-template #dropdownListAutocomplete>
  <dx-scroll-view
    class="dropdown-items-wrapper"
    [class.mac]="isMac"
    [height]="height"
    [width]="contentWidth ? dropdownWrapper.clientWidth : ''"
    direction="Both"
  >
    <div
      class="dropdown-item"
      *ngFor="let item of listValuesAutocomplete"
      (click)="selectItem(item)"
      statistic
      statisticElementName="Select item in any dropdowns"
    >
      <span class="dropdown-item__text">{{templateField ? item[templateField.list] : item}}</span>
      <div class="dropdown-item__divider"></div>
    </div>
  </dx-scroll-view>
</ng-template>

<ng-content></ng-content>
